import * as React from "react";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { Alert, CircularProgress } from "@mui/material";
import { purple } from "@mui/material/colors";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";

import background from "../static/background.jpg";
import logo from "../static/logo.png";

import { Formik, Field } from "formik";
import * as yup from "yup";

import axios from "axios";
import { UserContext } from "../contexts/user";
import { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Loading from "./Loading";
import { API_URL } from "../../src/App";
import Cookies from 'universal-cookie';
const cookies = new Cookies()

const theme = createTheme();

export default function SignInSide() {
  const [isLoading, setIsLoading] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = useState("");
  const [isPageLoading, setIsPageLoading] = useState(true);

  const { user, setUser } = useContext(UserContext);

  const navigate = useNavigate();

  useEffect(() => {
    axios.defaults.withCredentials = true 
    axios.post(`${API_URL}/session`,{ withCredentials: true }).then((res) => {
      if (res.data.username !== "not logged in") {
        navigate("/dashboard", { replace: true });
        setIsPageLoading(false);
      } else {
        setIsPageLoading(false);
      }
    });
  }, []);

  if (isPageLoading) {
    return <Loading />;
  }


  const initialValues = {
    username: "",
    password: "",
  };

  const userSchema = yup.object().shape({
    username: yup.string().required("Required"),
    password: yup
      .string()
      .required("Required"),

  });



  const handleSubmit = (values) => {
    setIsLoading(true);
    setErrorAlert(false);
    setErrorAlertMessage("");

    axios
      .post(`${API_URL}/checkLogin`, {
        values: values
      }, {withCredentials:true})
      .then((res) => {
        if (res.data.res === "login successful") {
          cookies.set('logged_in', 'logged_in',  {path: '/', secure: true, samesite: 'none'});
          axios.post(`${API_URL}/session`, { withCredentials: true,   credentials: 'include',}).then((res) => {
            setUser({
              username: res.data.username,
            });
            
          });

          navigate("/dashboard", { replace: true ,  state: {loc:'loginPage'}});
        } else {
          setErrorAlertMessage("You provided incorrect credentials");
          setErrorAlert(true);
          setIsLoading(false);
          
        }
      })
      .catch((error) => {
        setErrorAlertMessage("An error occured, please try again");
        setErrorAlert(true);
        setIsLoading(false);
        
      });
      
  };

  return (
    <ThemeProvider theme={theme}>
      <Grid
        container
        component="main"
        sx={{
          height: "100vh",
          backgroundImage: `url(${background})`,
          backgroundRepeat: "no-repeat",
          backgroundColor: (t) =>
            t.palette.mode === "light"
              ? t.palette.grey[50]
              : t.palette.grey[900],
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <CssBaseline />

        <Grid
          item
          xs={12}
          sm={8}
          md={5}
          component={Paper}
          elevation={6}
          square
          sx={{
            background:
              "linear-gradient(to right bottom, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.1))",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              my: 8,
              mx: 4,
              p: 5,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              backgroundColor: "white",
              boxShadow: "5",
              borderRadius: "16px",
            }}
          >
            <img src={logo} alt="alt text" width="60%" />
            <Typography component="h1" variant="h5">
              Sign in
            </Typography>

            <Formik
              onSubmit={handleSubmit}
              initialValues={initialValues}
              validationSchema={userSchema}
            >
              {({
                values,
                errors,
                touched,
                handleSubmit,
                handleChange,
               
              }) => (
                <Box
                  
                  id="loginform"
                  sx={{ mt: 1 }}
                >
                  {errorAlert ? (
                    <Alert
                      onClose={() => {
                        setErrorAlertMessage("");
                        setErrorAlert(false);
                      }}
                      severity="error"
                    >
                      {errorAlertMessage}
                    </Alert>
                  ) : (
                    <></>
                  )}

                  <form onSubmit={handleSubmit}>
                    <TextField
                      margin="normal"
                      fullWidth
                      id="username"
                      label="Username"
                      name="username"
                      // autoComplete="username"
                      autoFocus
                      value={values.username}
                      onChange={handleChange}
                      error={!!touched.username && !!errors.username}
                      helperText={touched.username && errors.username}
                    />
                    <TextField
                      margin="normal"
                      // required
                      fullWidth
                      name="password"
                      label="Password"
                      type="password"
                      id="password"
                      // autoComplete="current-password"
                      value={values.password}
                      onChange={handleChange}
                      error={!!touched.password && !!errors.password}
                      helperText={touched.password && errors.password}
                    />
                    <FormControlLabel
                      control={<Checkbox value="remember" color="primary" />}
                      label="Remember me"
                    />
                    <Box sx={{ m: 1, position: "relative" }}>
                      {/* {isLoading ? <CircularProgress /> : <></>} */}
                      <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        disabled={isLoading}
                        sx={{ mt: 3, mb: 2 }}
                      >
                        Sign In
                      </Button>
                      {isLoading && (
                        <CircularProgress
                          size={24}
                          sx={{
                            color: purple[500],
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            marginTop: "-8px",
                            marginLeft: "-8px",
                          }}
                        />
                      )}
                    </Box>
                    <Grid container>
                      <Grid item xs>
                        <Link href="#" variant="body2">
                          Forgot password?
                        </Link>
                      </Grid>
                      <Grid item>
                        <Link href="#" variant="body2">
                          {"Don't have an account? Sign Up"}
                        </Link>
                      </Grid>
                    </Grid>
                  </form>
                </Box>
              )}
            </Formik>
          </Box>
        </Grid>

        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              width: "75%",
            }}
          >
            <Accordion>
              <AccordionSummary
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>Dashboard</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  Check out the new and improved, personalized user dashboard,
                  with your most frequented functions right at your fingertips!
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary
                aria-controls="panel2a-content"
                id="panel2a-header"
              >
                <Typography>Graphs</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  Use the new graphing tools to drill down into the detail and
                  really impress at your next presentation!
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary
                aria-controls="panel3a-content"
                id="panel3a-header"
              >
                <Typography>Risk Tree</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  Look out! This sleeker, more responsive styling could be
                  coming to vanilla risk tree soon!
                </Typography>
              </AccordionDetails>
            </Accordion>
          </div>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}
